export const DATA_TYPES = {
  OBJECT: "object",
};
